import { FC } from 'react';

import { Flex, TableCell, TableHeader, TableRow, Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import {
    CAMPAIGNS_TABLE_COLUMNS_MAP,
    CampaignsTableColumn,
} from 'components/CampaignsDashboard/components/CampaignsTable/columns';
import { SelectAllCheckbox } from 'components/CampaignsDashboard/components/CampaignsTable/components/SelectAllCheckbox';
import { TableHeaderTooltip } from 'components/CampaignsDashboard/components/CampaignsTable/components/TableHeaderTooltip';
import { getCampaignsTableColumns } from 'components/CampaignsDashboard/utils/utils';

import { useSelector } from 'store/utils';

export const CampaignsTableHeader: FC = () => {
    const columnsPreset = useSelector((state) => state.campaignsFilters.columnsPreset);
    const columns = getCampaignsTableColumns(columnsPreset);
    const trls = useTrls();

    return (
        <TableHeader>
            <TableRow verticalAlign="middle">
                {columns.map((columnKey) => {
                    const { width, stickyLeft, trlKey, tooltipTrlKey } = CAMPAIGNS_TABLE_COLUMNS_MAP[columnKey];

                    return (
                        <TableCell key={columnKey} Element="th" width={width} stickyLeft={stickyLeft} align="left">
                            {columnKey === CampaignsTableColumn.Actions ? (
                                <SelectAllCheckbox />
                            ) : (
                                <Flex gap={4} align="center">
                                    <Text typography="label-3-regular" style="secondary">
                                        {trls(trlKey)}
                                    </Text>
                                    <TableHeaderTooltip tooltipText={tooltipTrlKey ? trls(tooltipTrlKey) : undefined} />
                                </Flex>
                            )}
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHeader>
    );
};
